export default function (ModalService) {
    return function (vehicleId, mileages, keepers) {
        return ModalService.showModal({
            controller: require('../../controllers/mileages/add/addMileageCtrl'),
            template: require('../../controllers/mileages/add/add-mileage.html'),
            controllerAs: 'addMileage',
            inputs: {
                vehicleId,
                mileages,
                keepers
            }
        });
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/mileages/openAddMileageModal.js